<template>
    <transition name="fade" @after-enter="afterEnter">
        <div class="popup" style="background-image: url('static/img/main/point2/popup/bg.png');" ref="popup">
            <div class="popup-bg delay3"></div>
            <div class="popup-inner ">
                <a href="#" class="close" @click.prevent="closePopup"></a>
                <div class="left delay6">
                    <div class="quotes quotes-right">
                    <span class="text">
                        Все мои поездки в эту страну были связаны со сноубордингом, тренировками в горах и наслаждением природой
                    </span>
                    </div>
                    <div class="info">
                    <span class="point">
                        <span class="text">
                            Базель, Швейцария
                        </span>
                    </span>
                        <h3 class="head">
                            Базель — историческая <br>
                            родина Weleda
                        </h3>
                        <span class="desc">
                           Сегодня Базель не сходит с газетных полос: в городе, расположенном между изумрудными вершинами Юры и Шварцвальда, три дюжины музеев, первоклассный музыкальный театр, сияющие штаб-квартиры крупнейших банков. Но чуть меньше ста лет назад Базель давал газетам совсем другие инфоповоды: в начале 1920-х в базельском пригороде Арлесхайм открылась первая в мире клиника антропософской медицины, основанная тремя энтузиастами — врачом, философом и фармацевтом. Главный принцип антропософской медицины — правильно стимулировать организм, чтобы тот сам боролся с болезнью, — близок взглядам Weleda, компании, которая выросла из маленькой лаборатории при арлесхаймской клинике.
                    </span>
                    </div>
                </div>
                <div class="right delay9">
                    <div class="popup-products">
                        <div class="info">
                            <h4 class="head">
                                Натуральные ингредиенты
                            </h4>
                            <span class="desc">
                                Для сохранения природной силы около 1000 натуральных ингредиентов сотрудники Weleda собирают растения быстро и минимально обрабатывают их: только таким образом вещества и активные компоненты раскрывают и сохраняют свои ценные качества.
                            </span>
                            <a href="https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%BD%D0%B0%D1%82%D1%83%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D1%81%D0%BC%D0%B5%D1%82%D0%B8%D0%BA%D0%B0-weleda?utm_source=afisha&utm_medium=card&utm_term=switzerland&utm_content=natural_cosmetics&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="btn" @click="gaEvents('places','click','know more ')">
                                Подробнее
                            </a>
                        </div>
                        <div class="img popup-products-img2 ">
                            <img src="static/img/main/point2/popup/product.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {TweenMax} from 'gsap';
    import  popupMix from '@/components/pages/popups/popup_mix.vue';

    export default {
        name: 'popup2',
        mixins: [popupMix],
    }
</script>



// WEBPACK FOOTER //
// popup2.vue?671807ec